import { FieldProps } from "formik";
import React from "react";
import MUISlider, { SliderProps as MUISliderProps } from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";
import Form from "../..";
import CurrencyInput from "../../CurrencyInput";

export interface OptionType {
	value: string;
	label: string;
}
export interface OptionGroupedType {
	label: string;
	options: OptionType[];
}

export interface SliderProps extends MUISliderProps {
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	name: string;
	onSliderChange?: (value: number | Array<number>) => void;
	className?: string;
	disabled?: boolean;
	addTextFields?: boolean;
	label: string;
	currencyLocale?: string;
}

const ASTSlider = withStyles({
	thumb: {
		height: 24,
		width: 24,
		marginTop: -10,
		marginLeft: -12,
	},
	rail: {
		height: 4,
		borderRadius: 4,
	},
	track: {
		height: 4,
		borderRadius: 4,
	},
})(MUISlider);

const Slider: React.FC<SliderProps> = ({
	field,
	form,
	id,
	name,
	onSliderChange,
	className,
	disabled,
	addTextFields = false,
	label,
	currencyLocale,
	...props
}) => {
	const realName = field?.name || name;

	const handleChange = (evt: any, value: any) => {
		form?.setFieldValue(realName, value);
		if (onSliderChange) {
			onSliderChange(value);
		}
	};

	const value = field?.value;
	return (
		<>
			<div className={`form-slider`}>
				<ASTSlider
					//{...field}
					name={realName}
					value={value}
					onBlur={() => {
						form?.setFieldTouched(realName, true);
					}}
					//@ts-ignore
					onChange={handleChange}
					disabled={disabled}
					{...props}
					className={`react-slider-container ${className}`}
				/>
				{addTextFields && (
					<div className="d-flex justify-space-between">
						{Array.isArray(value) && value.length === 2 && (
							<>
								{currencyLocale ? (
									<CurrencyInput
										label={`${label} minimum`}
										id={`${realName}[0]`}
										name={`${realName}[0]`}
										currency={currencyLocale}
										hiddenLabel
										disabled={disabled}
										defaultValue={"0"}
										className="slider-min"
										hideDecimals
									/>
								) : (
									<Form.Field
										type="number"
										label={label}
										hiddenLabel
										id={`${realName}[0]`}
										name={`${realName}[0]`}
										min={props.min}
										max={value[1]}
										className="m-right slider-min"
									/>
								)}
								{Array.isArray(value) && value.length === 2 && (
									<>
										{currencyLocale ? (
											<CurrencyInput
												label={`${label} maximum`}
												id={`${realName}[1]`}
												name={`${realName}[1]`}
												currency={currencyLocale}
												hiddenLabel
												disabled={disabled}
												className="slider-max"
												hideDecimals
											/>
										) : (
											<Form.Field
												type="number"
												label={label}
												hiddenLabel
												id={`${realName}[1]`}
												name={`${realName}[1]`}
												min={value[0]}
												max={props.max}
												className="m-left"
											/>
										)}
									</>
								)}
								{!Array.isArray(value) && (
									<>
										{currencyLocale ? (
											<CurrencyInput
												label={`${label} maximum`}
												id={`${realName}`}
												name={`${realName}`}
												currency={currencyLocale}
												hiddenLabel
												disabled={disabled}
												className="slider-value"
												hideDecimals
											/>
										) : (
											<Form.Field
												type="number"
												label={label}
												hiddenLabel
												id={`${realName}`}
												name={`${realName}`}
												min={props.min}
												max={props.max}
												className="m-left slider-max"
											/>
										)}
									</>
								)}
							</>
						)}
					</div>
				)}
			</div>
		</>
	);
};

export default Slider;
